import { useSelector } from 'react-redux';
import { useUrlQuery } from '../../components/ApplicationProviders/UrlQueryProvider/UrlQueryProvider';
import { selectUser } from '../Analytics/new-analytics';
import { useGradualRollout } from '../../utilities/useGradualRollout';
import { GradualReleaseLabels } from '../../utilities/useGradualRolloutTypes';
import { PageView } from '../../models/analytics';

/**
 * useRegionSelection determines wheter or not the user should be exposed to the region selection test group.
 * Since we don't want to expose risky changes to a high number of users AND we want to abide by
 * the requirement from data analytics of having a 50% split between test/control in an A/B test.
 * We first need to get an initial 40% of traffic to be considered in the a/b test, and from that group there
 * is a 50% chance that they enter the a/b test.
 */
export const useRegionSelection = () => {
  const { market, clientId } = useUrlQuery();
  const user = useSelector(selectUser);
  const userId = user?.id || '';

  const { isInTestGroup } = useGradualRollout(
    PageView.NO_SCREEN,
    GradualReleaseLabels.DEFAULT_FLOWS_REGION_SELECTION_40
  );

  const { isInTestGroup: isInABTestGroup } = useGradualRollout(
    PageView.NO_SCREEN,
    GradualReleaseLabels.DEFAULT_FLOWS_REGION_SELECTION_AB_20
  );

  return {
    isInTestGroup: () =>
      isInTestGroup({ userId, market, clientId }) && isInABTestGroup({ userId, market, clientId }),
  };
};
